export default __webpack_public_path__ + "static/media/Key visual 40x40.53af95a8.svg";